import { PrimaryButton } from 'Components/Buttons';
import CloseButton from 'Components/modals/CloseButton';
import { Heading, Layer, RadioButtonGroup } from 'grommet';
import { useCallback, useEffect, useState } from 'preact/hooks';
import { connect } from 'react-redux';
import { buildURL } from 'Shared/fetch';
import useFetch from 'use-http';

import style from './style.scss';

const reasons = [
  { text: 'I would like to see more animals', placeHolder: 'Tell us what animals would you like to see' },
  { text: 'Too expensive', placeHolder: 'What would make zoolife worth paying for?' },
  { text: 'I would like to see more talks', placeHolder: false },
  {
    text: 'I would like to see different types of talks',
    placeHolder: 'Tell us what kind of talks you would like to attend',
  },
  { text: 'I only use zoolife for school', placeHolder: 'In what months would you use zoolife' },
  { text: 'Technical difficulties', placeHolder: 'Tell us more' },
  { text: 'Other', placeHolder: 'Tell us more' },
];

const CancelReasonsModal = ({ onClose, onSubmit }) => {
  const [reason, setReason] = useState({});
  const [text, setText] = useState('');

  const onChangeHandler = useCallback((event) => {
    const selected = reasons.find(({ text }) => text === event.target.value);
    setReason(selected);
    if (!selected.placeHolder) {
      setText('');
    } else {
      setTimeout(() => {
        document.getElementById('cancelText').focus();
        document.getElementById('cancelButton').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
    }
  }, []);
  const { post, data, error, loading } = useFetch(buildURL('/users/subscription/cancelReason'), {
    credentials: 'include',
    cachePolicy: 'no-cache',
  });

  useEffect(() => {
    if (error) {
      console.error('Error while sending cancellation reason:', error);
      onSubmit();
    }
  }, [error, onClose, onSubmit]);

  useEffect(() => {
    if (data) {
      onSubmit();
    }
  }, [data, onSubmit]);

  const submitHandler = () => {
    post({ reason: reason.placeHolder ? `${reason.text}: ${text}` : reason.text });
  };

  return (
    <Layer onClickOutside={onClose} onEsc={onClose} className={style.cancelReasonContainer}>
      <CloseButton varient="grey" onClick={onClose} className={style.close} />
      <Heading level="4" color="var(--charcoal)">
        We will miss you in our community!
      </Heading>
      <div className={style.container}>
        <div>
          <p>
            We are a small team but we are working tirelessly to improve your zoolife experience. Your membership helps us
            continue our mission of connecting humankind with wildlife no matter where you are.
          </p>
          <p>If you are still interested in canceling your membership, please let us know why.</p>

          <RadioButtonGroup
            name="reasons"
            className={style.radioButtons}
            options={reasons.map(({ text }) => text)}
            value={reason.text}
            onChange={onChangeHandler}
          />

          {reason?.placeHolder && (
            <textarea
              id="cancelText"
              cols="30"
              rows="10"
              maxLength="1500"
              placeholder={reason.placeHolder}
              value={text}
              onChange={(event) => setText(event.target.value)}
            />
          )}

          <div className={style.buttonsContainer} id="cancelButton">
            <PrimaryButton
              type="button"
              label="Submit"
              onClick={submitHandler}
              loading={loading}
              disabled={!reason?.text || (reason.placeHolder && text.trim() === '')}
            />
          </div>
        </div>
      </div>
    </Layer>
  );
};

export default connect(
  ({
    user: {
      subscription: { validUntil },
    },
  }) => ({ validUntil }),
)(CancelReasonsModal);
